import { option } from 'fp-ts';
import { pipe } from 'fp-ts/function';

import { composeProps } from '@mews/framework/redux';

import { getEnterpriseChildSelectionEnabled } from '../../../modules/configuration/selectors';
import {
    getAgeCategoryName,
    getSortedAgeCategoryIds,
    getSortedAgeCategoryWithoutChildrenIds,
} from '../../../modules/entities/ageCategories/selectors';
import { enterpriseServiceIdPropsExtender } from '../../../modules/entities/services/selectors';
import { localizeProperty } from '../../../modules/globalization/selectors';
import { ApplicationState } from '../../../types';
import { WithAgeCategoryId } from '../../../types/selectors/selectorPropTypes';

export const getSortedEnterpriseAgeCategories = composeProps((state, { serviceId, enterpriseId }) => {
    const enabledChildSelection = getEnterpriseChildSelectionEnabled(state, { enterpriseId });
    if (serviceId != null && enabledChildSelection !== true) {
        return getSortedAgeCategoryWithoutChildrenIds(state, { serviceId });
    } else if (serviceId != null) {
        return getSortedAgeCategoryIds(state, { serviceId });
    }
    return [];
}, enterpriseServiceIdPropsExtender);

export const getAgeCategoryLocalizedName = (state: ApplicationState, { ageCategoryId }: WithAgeCategoryId) =>
    pipe(
        getAgeCategoryName(state, { ageCategoryId }),
        option.map((name) => localizeProperty(state, { property: name })),
        option.getOrElseW(() => '')
    );
